import styles from "../styles/ResidentForm.module.css";
// import { useSelector } from "react-redux";
import { useState } from "react";

import { UPDATE_RMS_MGMT_INFO } from "../../api/apiPath";
import http from "../../api/server";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from 'libphonenumber-js';

const FORMDATA = {
  Name: "",
  primaryEmail: "",
  mobileNumber: "", // default to a valid UK mobile number format
  mobileCountryCode: "gb", // default to UK
};

function ManagerDetails(props) {
  const { onCancel, managerData, setReloadmanager } = props;
  //   const { userObj } = useSelector((state) => state.user);
  const [formData, setFormData] = useState(managerData);
  const [errors, setErrors] = useState(FORMDATA);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const [responseMessage, setResponseMessage] = useState({
    show: false,
    message: "",
  });

  const handleDisableSave = (data) => {
    return(
      data?.Name === "" ||
        data?.Name === undefined ||
        data?.mobileNumber === "" ||
        data?.mobileNumber === undefined ||
        data.mobileNumber === "+" 
    );
  };
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(
    handleDisableSave(managerData)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = formData;

    // Auto-format postcode
    let formattedValue = value;
    updatedFormData = { ...formData, [name]: formattedValue };
    setFormData(updatedFormData);
    setIsSubmitDisabled(handleDisableSave(updatedFormData));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.Name) newErrors.Name = "Name is required";
    if (!formData.mobileNumber)
      newErrors.mobileNumber = "Mobile number is required";
    if (
      formData.mobileNumber
        .replace(formData?.dialCode, "")
        .replace(/^\+/, "") === ""
    )
      newErrors.mobileNumber = "Mobile number is required";
    if(formData.mobileNumber && !isValidPhoneNumber(formData.mobileNumber, formData.mobileCountryCode))
      newErrors.mobileNumber = "Enter valid mobile number";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      console.log("Form submitting...", formData);
      setIsSubmitting(true);
      try {
        const rawNumber = formData?.mobileNumber
          .replace(formData?.dialCode, "")
          .replace(/^\+/, "");
        const payload = {
          buildingManagedBy: formData?.Name || "",
          email: formData?.primaryEmail || "",
          phone: `+${formData?.dialCode}-${rawNumber}` || "",
        };
        console.log(payload);
        const updateResponse = await http.put(
          UPDATE_RMS_MGMT_INFO,
          JSON.stringify(payload)
        );
        if (updateResponse?.status === 200) {
          setResponseMessage({
            ...responseMessage,
            show: true,
            message: "Profile updated successfully.",
          });
        } else {
          setResponseMessage({
            ...responseMessage,
            show: true,
            message: `Error in profile update: ${updateResponse.data}`,
          });
        }
      } catch (error) {
        setResponseMessage({
          ...responseMessage,
          show: true,
          message: `Error in profile update: ${error.data}`,
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="approval-modal-content" style={{ height: "auto" }}>
        <span
          className="close"
          onClick={() => {
            onCancel();
          }}
        >
          &times;
        </span>
        <h4 className="modal-header">Update Manager Details</h4>{" "}
        {/* Modal Header */}
        {responseMessage?.show === true ? (
          <div className="modal-body d-flex flex-column align-items-center justify-content-center m-3">
            <h6>{responseMessage.message}</h6>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={() =>{ setReloadmanager(true); onCancel()}}
              style={{ width: "25%" }}
            >
              Close
            </button>
          </div>
        ) : (
          <div className="modal-body">
            <div className="modal-card p-3">
              <div className="d-flex flex-column gap-2">
                <div className="form-group">
                  <label htmlFor="flotingName">
                    Building Managed By<span className="astrik">*</span>:
                  </label>
                  <input
                    className="form-control"
                    id="flotingName"
                    type="text"
                    placeholder="Enter first name"
                    name="Name"
                    value={formData?.Name}
                    onChange={handleChange}
                  />

                  {errors?.Name && (
                    <span className={styles.formError}>{errors?.Name}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="countruPhone">
                    Mobile Number<span className="astrik">*</span>:
                  </label>

                  <PhoneInput
                    country={formData.mobileCountryCode}
                    value={formData.mobileNumber}
                    onChange={(phone, data) => {
                      console.log(phone, data);
                      if (!phone.startsWith("+")) phone = "+" + phone;
                      const updatedFormdata = {
                        ...formData,
                        mobileNumber: phone,
                        dialCode: data.dialCode,
                        mobileCountryCode:
                          data.countryCode || formData.mobileCountryCode, // set country code on change
                      };
                      setFormData(updatedFormdata)
                      setIsSubmitDisabled(handleDisableSave(updatedFormdata))
                    }}
                    inputProps={{
                      name: "mobileNumber",
                      required: true,
                      id: "countryPhone",
                      className: "form-control react-tel-input",
                      style: {
                        width: "100% !important",
                        padding: "1rem 2.75rem",
                        // height:
                        //   "calc(3.5rem + calc(var(--bs-border-width) * 2))",
                        minHeight:
                          "calc(2.5rem + calc(var(--bs-border-width) * 2))",
                        lineHeight: "1.25",
                      },
                    }}
                    containerClass="w-100"
                    inputClass="w-100 react-tel-input"
                    enableSearch
                    placeholder="Enter mobile number"
                  />
                  {errors?.mobileNumber && (
                    <span className={styles.formError}>
                      {errors?.mobileNumber}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="flotingName">Email:</label>
                  <input
                    className="form-control"
                    id="flotingName"
                    type="text"
                    placeholder="First Name"
                    name="email"
                    value={formData.primaryEmail}
                    disabled
                    // onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end gap-3 px-3">
              <>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => onCancel()}
                  style={{ width: "25%" }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={isSubmitting || isSubmitDisabled}
                  style={{ width: "25%" }}
                  onClick={(e) => handleSubmit(e)}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ManagerDetails;
